import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Logout from "./components/Logout/Logout";
import Home from "./pages/Home";
import Documentation from './pages/Documentation';
import ReportBuilder from "./pages/ReportBuilder";
import Dashboards from "./pages/Dashboards";
import {useSessionContext} from "./util/SessionContext";

// Every route this app has.
//
// THREE, and that is the point of the app existing. Reporting spent phases 0-3 as a hidden guest in
// t5, where it was one unlinked route among forty and could not be reached without typing a URL.
// Here it IS the app, so it is the landing destination, it is in the rail, and there is no boundary
// test keeping it out of one -- reportingBoundary.test.ts was deleted in the move because it has
// nothing to say in a repo where the reporting code is not a guest.
//
// NO DOCUMENTATION PAGE YET. t5's listed twelve guides, none of which are this app's subject, and an
// index of nothing is the shape that has been removed from this suite twice already. It comes back
// when there is a reporting guide to put in it.
//
// THE REPORTING BACKEND IS cres-aws-t10. Reports and the report store address it absolutely; login,
// positions, notifications and pick values still go to t5, which is why there are two base URLs
// and there does not need to be one, which is what made this a frontend-only extraction. See
// docs/reporting/roadmap.md.

function RequireAuth({children}) {
    const sessionContext = useSessionContext();
    const location = useLocation();

    if (!sessionContext.getAccessToken()) {
        // THE MISSING HALF OF postLoginRedirect. That module reads this key, clears it and
        // validates it, and all three ways in already call it -- Login2 on success, SwitchAccount,
        // and useSsoLogin both after an SSO hand-off and after a persona is chosen. Nothing had
        // ever WRITTEN it, so every one of those consumers was reading an empty box.
        //
        // The visible cost was a scheduled report's email: it links to one run,
        // `/reporting?run=<usid>`, which is the one place somebody arrives at this app with no
        // context at all. Signed out, they were sent here, signed in, chose a persona, and landed
        // on the home page with the link gone and nothing to say why.
        //
        // STORAGE RATHER THAN THE ROUTER STATE BELOW, which is why that state was never enough:
        // choosing a persona renders only that dialog and unmounts the router, and an SSO sign-in
        // leaves the origin entirely. Neither survives; session storage does.
        try {
            sessionStorage.setItem("postLoginRedirect", `${location.pathname}${location.search}`);
        } catch {
            // A blocked store is not a broken page -- the cost is landing on home, which is
            // exactly what happened before this line existed.
        }
        return <Navigate to="/" replace state={{
            referrer: {
                pathname: location.pathname,
                search: location.search,
            },
        }} />;
    }

    return children;
}

export default function AppRoutes() {
    return (
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/reporting" element={<RequireAuth><ReportBuilder /></RequireAuth>} />
            {/* TWO PATHS, ONE PAGE. A dashboard is small enough that a separate editor would be
                two screens showing the same thing, so the list and one dashboard are the same
                component reading its own USID. */}
            <Route exact path="/dashboards" element={<RequireAuth><Dashboards /></RequireAuth>} />
            <Route exact path="/dashboards/:usid" element={<RequireAuth><Dashboards /></RequireAuth>} />
            <Route exact path="/documentation" element={<RequireAuth><Documentation /></RequireAuth>} />
            <Route exact path="/logout" element={<Logout />} />
            <Route path="/*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
